document.addEventListener("DOMContentLoaded", () => {

  // Function to find Hazmat Fee and remove buttons
  function disableHazmatButtons() {
    document.querySelectorAll('[data-smartcart-items] li').forEach(item => {
      const titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
      if (!titleEl) return;

      const title = titleEl.textContent.trim();

      if (title === "Hazmat Fee") {
        // Remove trash button
        const trashBtn = item.querySelector(".rebuy-cart__flyout-item-remove");
        if (trashBtn) trashBtn.remove();

        // Remove quantity +/- buttons
        const qtyButtons = item.querySelectorAll(".rebuy-cart__flyout-item-quantity-widget-button");
        qtyButtons.forEach(btn => btn.remove());
      }
    });
  }

  // Run immediately on page load
  disableHazmatButtons();

  // Watch for dynamic updates (Rebuy SmartCart loads async)
  const observer = new MutationObserver(() => {
    disableHazmatButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener("rebuy:cart.change", async (e) => {
  if (!window.boxRuleConfig) {
    console.warn('Box rule config not found');
    return;
  }

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    const hiddenVariantId = window.boxRuleConfig.hiddenProductVariantId;
    let totalSmallBoxQty = 0;
    let totalLargeBoxQty = 0;
    let currentFeeQty = 0;
    let currentFeeItem = null;

    cart.items.forEach(item => {
      if (item.variant_id === hiddenVariantId) {
        currentFeeQty = item.quantity;
        currentFeeItem = item;
        return;
      }

      const isSmallBox = window.boxRuleConfig.smallBoxIds.includes(item.product_id);
      const isLargeBox = window.boxRuleConfig.largeBoxIds.includes(item.product_id);

      if (isSmallBox) totalSmallBoxQty += item.quantity;
      if (isLargeBox) totalLargeBoxQty += item.quantity;
    });

    const requiredFeeQty = (1 + Math.floor((totalSmallBoxQty - 1) / window.boxRuleConfig.smallThreshold)) + totalLargeBoxQty;

    let action = 'none';
    if (requiredFeeQty === 0 && currentFeeQty > 0) {
      action = 'remove';
    } else if (requiredFeeQty > 0 && currentFeeQty === 0) {
      action = 'add';
    } else if (requiredFeeQty > 0 && requiredFeeQty !== currentFeeQty) {
      action = 'update';
    }

    if (action !== 'none') {
      console.log(`Hazmat fee action: ${action}, required qty: ${requiredFeeQty}`);
      
      let endpoint, body;
      
      if (action === 'add') {
        endpoint = '/cart/add.js';
        body = JSON.stringify({
          items: [{ id: hiddenVariantId, quantity: requiredFeeQty }]
        });
      } else {
        endpoint = '/cart/update.js';
        body = JSON.stringify({
          updates: { [hiddenVariantId]: requiredFeeQty }
        });
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      });

      if (!response.ok) {
        throw new Error(`Failed to ${action} hazmat fee`);
      }

      const result = await response.json();
      console.log(`Hazmat fee ${action} successful:`, result);

      window.Rebuy?.SmartCart?.refresh?.();
    }

  } catch (error) {
    console.error('Error managing hazmat fee in Rebuy cart:', error);
  }
});